/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import colors from '../../../../../../constants/colors';
import { TEAMS } from '../../../../../../constants/teamNames';
import { DATE_RANGES } from '../../../../../../constants/dateRanges';
import AlertType from '../../../../../../constants/alertType';

const filters = {
  custom: 'Custom',
  thisWeek: 'This Week'
}

const useStyles = makeStyles(() => ({
  root: {
    margin: '0 14px',
  },
  title: {
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    color: colors.blue,
    marginTop: '8px',
    marginBottom: '6px',
    fontSize: '1.6rem',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '6px',
    flexWrap: 'wrap',
    gap: '4px',
  },
  box: {
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '120%',
    height: '33px',
    paddingLeft: '5px',
    paddingRight: '5px',
    minWidth: '70px',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #e8f7fc 0%, #cdf0f8 100%)',
    border: '1px solid #a0d8ef',
    borderRadius: '4px',
    color: '#2a3a42',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #c8eef8 0%, #a0e0f5 100%)',
      color: '#1a5fa8',
    },
  },
  boxActive: {
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '120%',
    minWidth: '70px',
    height: '33px',
    paddingLeft: '5px',
    paddingRight: '5px',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #00d5fd 0%, #0495ff 50%, #0072ee 100%)',
    border: '1px solid transparent',
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0, 180, 220, 0.3)',
    color: colors.white,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
  },
  boxDisabled: {
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '120%',
    minWidth: '70px',
    height: '33px',
    paddingLeft: '5px',
    paddingRight: '5px',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #d0d8e0 0%, #e8edf2 100%)',
    border: '1px solid #c0cdd8',
    borderRadius: '4px',
    color: '#a0aab4',
    cursor: 'not-allowed',
    display: 'flex',
    justifyContent: 'center',
  }
}));

const Filters = ({ selectedFilters, onChange }) => {
  const classes = useStyles('');
  const selectedAlertType = useSelector((state) => state.Alerts.selectedAlert);
  const team = TEAMS.find((t) => selectedFilters.findIndex((f) => f === t.name) > -1);
  const dateRange = DATE_RANGES.find((t) => selectedFilters.findIndex((f) => f === t.name) > -1);

  const [selectedTeam, setSelectedTeam] = useState(team);
  const [selectedDateRange, setSelectedDateRange] = useState(dateRange);

  if ((!team && selectedTeam) || (team && !selectedTeam)) {
    setSelectedTeam(team);
  }

  if ((!dateRange && selectedDateRange) || (dateRange && !selectedDateRange)) {
    setSelectedDateRange(dateRange);
  }

  const onClickTeam = (_team) => {
    setSelectedTeam(_team);
    if (!selectedDateRange) {
      setSelectedDateRange(DATE_RANGES[0]); // TODAY
    }
    onChange([_team.name, selectedDateRange ? selectedDateRange.name : DATE_RANGES[0].name]);
  };

  const onClickDateRange = (_dateRange) => {
    setSelectedDateRange(_dateRange);
    if (!selectedTeam) {
      setSelectedTeam(TEAMS[0]); // MY_TEAM
    }
    onChange([selectedTeam ? selectedTeam.name : TEAMS[0].name, _dateRange.name]);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.title}>
        Filters
      </Box>
      <Box className={classes.row}>
        {TEAMS.map((_team) => (
          <Box
            className={selectedTeam && selectedTeam.name === _team.name
              ? classes.boxActive : classes.box}
            key={_team.name}
            onClick={() => onClickTeam(_team)}
          >
            {_team.label}
          </Box>
        ))}
      </Box>
      <Box className={classes.row}>
        {DATE_RANGES.map((_dateRange) => {
          let rangeFilter = (
            <Box
              className={selectedDateRange && selectedDateRange.name === _dateRange.name
                ? classes.boxActive : classes.box}
              key={_dateRange.name}
              onClick={() => onClickDateRange(_dateRange)}
            >
              {_dateRange.label}
            </Box>
          )
          if (selectedAlertType === AlertType.performance && _dateRange.label === filters.thisWeek) {
            rangeFilter = (
              <Box
                className={classes.boxDisabled}
                key={_dateRange.name}
              >
                {_dateRange.label}
              </Box>
            )
          } 
          if (selectedAlertType === AlertType.performance &&  _dateRange.label === filters.custom) {
            rangeFilter = (
              <Box
                className={classes.boxDisabled}
                key={_dateRange.name}
              >
                {_dateRange.label}
              </Box>
            )
          } 
          return rangeFilter;
        })}
      </Box>
    </Box>
  );
};

Filters.propTypes = {
  selectedFilters: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

Filters.defaultProps = {
  selectedFilters: [],
};

export default Filters;
